import { SubscribeBarsCallback } from 'public/charting_library/charting_library'
import { io, Socket } from 'socket.io-client'

import { Token } from '@/hooks/services/useTokenInfo'

import { KLine } from './DataFeed'

export default class SocketIO {
  socket: Socket
  isConnected = false
  subscribeStack: Map<
    string,
    {
      event: string
      params: { mint: string; period?: string }
      isSubscribed: boolean
    }
  > = new Map()
  constructor() {
    this.socket = io(import.meta.env.VITE_API_WSS_URL, {
      path: '/socket.io/',
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      withCredentials: true
    })
    this.socket.on('connect', this.onConnect.bind(this))
    this.socket.on('disconnect', this.onDisconnect.bind(this))
    this.socket.connect()
  }

  generatelistenerGuid(mint: string, period: string) {
    return `${mint}_#_${period}`
  }
  parsinglistenerGuid(listenerGuid: string): [string, string] {
    // listenerGuid = mint_#_period
    const [mint, , period] = listenerGuid.split('_')
    return [mint, period]
  }

  onConnect() {
    console.log('>>>>>> SocketIO: onConnect')
    this.isConnected = true
    this.subscribeStack.forEach(
      ({ event, params, isSubscribed }, listenerGuid) => {
        if (!isSubscribed) {
          this.socket.emit(event, params)
          this.subscribeStack.set(listenerGuid, {
            event,
            params,
            isSubscribed: true
          })
        }
      }
    )
  }
  onDisconnect() {
    console.log('>>>>>> SocketIO: onDisconnect')
    this.isConnected = false
    this.subscribeStack.forEach(({ event, params }, listenerGuid) => {
      this.subscribeStack.set(listenerGuid, {
        event,
        params,
        isSubscribed: false
      })
    })
  }

  subscribeKline(
    listenerGuid: string,
    params: { mint: string; period: string },
    onTick: SubscribeBarsCallback
  ) {
    console.log('>>>>>> subscribeKline: ', { listenerGuid, params })

    if (this.isConnected) this.socket.emit('kline', params)
    this.subscribeStack.set(listenerGuid, {
      event: 'kline',
      params,
      isSubscribed: this.isConnected
    })
    this.socket.on('kline', (kline: KLine) => {
      if (kline.mint === params.mint) {
        onTick({
          time: kline.id * 1000,
          open: parseFloat(kline.open),
          high: parseFloat(kline.high),
          low: parseFloat(kline.low),
          close: parseFloat(kline.close)
        })
      }
    })
  }

  subscribeTokenInfo(
    listenerGuid: string,
    params: { mint: string },
    onTick?: (tokenInfo: Token) => void
  ) {
    console.log('>>>>>> subscribeTokenInfo: ', { listenerGuid, params })

    if (this.isConnected) this.socket.emit('token', params)
    this.subscribeStack.set(listenerGuid, {
      event: 'token',
      params,
      isSubscribed: this.isConnected
    })
    this.socket.on('token', (tokenInfo: Token) => {
      onTick?.(tokenInfo)
    })
  }

  unsubscriber(listenerGuid: string) {
    // const [mint, period] = this.parsinglistenerGuid(listenerGuid)
    // this.socket.emit('unsubscribeKline', { mint, period })
    this.subscribeStack.delete(listenerGuid)
    console.log('>>>>>> this.subscribeStack: ', this.subscribeStack)
  }

  destroy() {
    this.socket.disconnect()
  }
}
